import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
//import { faHashtag, faEnvelope, faPhoneVolume } from '@fortawesome/duotone-light-svg-icons'
import { useEffect, useState } from "react";
import Apiservice from "../Apiservice";

const AllStaff = () => {
    const navigator = useNavigate();
    const [staffs, setStaffs] = useState([]);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        const currentDate = new Date();

        // Extract year, month, and day
        const year = currentDate.getFullYear();
        const month = (currentDate.getMonth() + 1).toString().padStart(2, '0'); // Month is 0-indexed, so add 1
        const day = currentDate.getDate().toString().padStart(2, '0'); // Pad with leading zero if needed

        const formattedDate = `${year}-${month}-${day}`;
        let data = {
            entryTime: formattedDate,
            includeOpenAttendance: true,
            include24HoursAttendance: true,
            status: 0
        }
        const token = localStorage.getItem("access_token");

        // Define custom headers
        const headers = {
            access_token: token, // Pass the token in the Authorization header
        };
        const fetchData = async () => {
            let result = await Apiservice.AllUser(data, headers);
            if (result.success === true) {
                setStaffs(result.data || []);
                setLoading(false);

            } else {
                console.error("Failed to fetch staff data:", result.message);
            }
        };

        fetchData();
    }, [])
    const handleDoubleClick = (data) => {
        navigator(`/staffprofile/${data.id}`)
    }
    console.log("staffs", staffs)
    return (
        <>
            <div className="container-fluid p-md-2 shadow" style={{ backgroundColor: 'lemonchiffon', userSelect: 'none' }}>
                <div className="row mb-2">
                    {loading ? (
                        <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
                            <div className="text-center">
                                {/* Spinner with proper rotation */}
                                <div
                                    className="spinner-border text-primary"
                                    role="status"
                                    style={{
                                        width: "2rem",
                                        height: "2rem",
                                        borderWidth: "3px",
                                    }}
                                >
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                                {/* Minimalist Text */}
                                <p className="mt-2 text-secondary small fw-semibold">Please wait...</p>
                            </div>
                        </div>
                    )
                        :
                        (
                            <>
                                <div className="col-12">
                                    <div className="row text-center mb-1">
                                        <div className="col text-dark fw-bold h5">
                                            57 PEACE PROTECTION PTE LTD EMPLOYEES
                                        </div>
                                    </div>
                                    <div className="row g-2 mb-2">

                                        <div className="col-12 col-md-2 d-grid">
                                            <button
                                                className="btn btn-outline-primary btn-sm"
                                                onClick={() => navigator('/pwmprogression')}
                                            >
                                                PWM Progression
                                            </button>
                                        </div>

                                        <div className="col-12 col-md-2 d-grid">
                                            <button
                                                className="btn btn-outline-primary btn-sm"
                                                onClick={() => navigator('/floatercredits')}
                                            >
                                                Floater Staff
                                            </button>
                                        </div>

                                        <div className="col-12 col-md-2 d-grid">
                                            <button
                                                className="btn btn-outline-primary btn-sm"
                                                onClick={() => navigator('/staffadd')}
                                            >
                                                Add Staff
                                            </button>
                                        </div>

                                    </div>
                                    <div className="row mb-2 d-flex">
                                        {
                                            staffs.length > 0 ? (
                                                staffs.map((staff) => (
                                                    <div
                                                        className="col-md-3 col-11 my-3 d-flex justify-content-center"
                                                        key={staff.id} onDoubleClick={() => handleDoubleClick(staff)}
                                                    >
                                                        <div
                                                            className="card shadow-lg border-0"
                                                            style={{
                                                                borderRadius: '15px',
                                                                height: '420px', // Fixed height for uniform cards
                                                                width: '100%', // Ensure consistent width
                                                                overflow: 'hidden',
                                                                transition: 'transform 0.3s ease',
                                                            }}
                                                            onMouseEnter={(e) =>
                                                                (e.currentTarget.style.transform = 'scale(1.05)')
                                                            }
                                                            onMouseLeave={(e) =>
                                                                (e.currentTarget.style.transform = 'scale(1)')
                                                            }
                                                        >
                                                            {/* Card Header Image */}
                                                            <div
                                                                className="card-image-top bg-light d-flex justify-content-center align-items-center"
                                                                style={{
                                                                    height: '150px',
                                                                    position: 'relative',
                                                                }}
                                                            >
                                                                <img
                                                                    src={staff.profileImage || 'default-avatar.jpg'}
                                                                    alt="Profile"
                                                                    className="img-fluid"
                                                                    style={{
                                                                        borderRadius: '50%',
                                                                        width: '100px',
                                                                        height: '100px',
                                                                        border: '4px solid #fff',
                                                                        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)',
                                                                    }}
                                                                />
                                                            </div>

                                                            {/* Card Body */}
                                                            <div className="card-body text-center bg-white d-flex flex-column justify-content-between">
                                                                <div>
                                                                    <h5 className="h5 text-dark fw-bold mb-1">
                                                                        {staff.firstName} {staff.lastName}
                                                                    </h5>
                                                                    <p className="text-muted mb-0">
                                                                        {staff.site.length > 0 ? staff.site[0].name : 'Not Assigned'}
                                                                    </p>
                                                                    <p className="text-muted mb-0">
                                                                        {staff.role}
                                                                    </p>
                                                                    {
                                                                        console.log("staff", staff)
                                                                    }
                                                                    <span
                                                                        className={`badge mb-1 ${staff.isPresent === 1
                                                                            ? 'bg-warning'
                                                                            : staff.isPresent === 2
                                                                                ? 'bg-success'
                                                                                : 'bg-danger'
                                                                            }`}
                                                                    >
                                                                        {staff.isPresent === 1
                                                                            ? 'Working'
                                                                            : staff.isPresent === 2
                                                                                ? 'Work Completed'
                                                                                : 'Absent'}
                                                                    </span>
                                                                </div>
                                                                <div
                                                                    className="d-flex flex-column align-items-start bg-light rounded p-2"
                                                                    style={{
                                                                        backgroundColor: '#f9f9f9',
                                                                        border: '1px solid #e0e0e0',
                                                                    }}
                                                                >
                                                                    <div className="d-flex align-items-center mb-1">
                                                                        <FontAwesomeIcon
                                                                            // icon={faHashtag}
                                                                            className="text-primary me-2"
                                                                        />
                                                                        <span className="text-dark">{staff.employeeId}</span>
                                                                    </div>
                                                                    {
                                                                        staff.emailId && (
                                                                            <>
                                                                                <div className="d-flex align-items-center mb-1">
                                                                                    {/* <FontAwesomeIcon icon={faEnvelope} className="text-success me-2" /> */}
                                                                                    <span
                                                                                        className="text-dark text-break"
                                                                                        style={{ fontSize: staff.emailId.length > 15 ? "14px" : "15px", wordBreak: "break-word" }}
                                                                                    >
                                                                                        {staff.emailId}
                                                                                    </span>
                                                                                </div>
                                                                            </>
                                                                        )
                                                                    }


                                                                    <div className="d-flex align-items-center">
                                                                        <FontAwesomeIcon
                                                                            // icon={faPhoneVolume}
                                                                            className="text-warning me-2"
                                                                        />
                                                                        <span className="text-dark">
                                                                            {staff.countryCode + staff.mobileNo}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))
                                            ) : (
                                                <h3 className="text-center text-muted">No staff Found</h3>
                                            )
                                        }

                                    </div>
                                </div>
                            </>
                        )}

                </div>
            </div>
        </>
    )
}
export default AllStaff;